import { default as isValidDomainLib } from 'is-valid-domain';
/**
 * Takes a string and checks if it is a valid domain.
 */
export const isValidDomain = (domain) => {
    return isValidDomainLib(domain, { subdomain: true });
};
/**
 * Check if it's any domain, without www. prefix
 *
 * @param domain string
 */
export const isBasicValidDomain = (domain) => {
    if (domain.toLowerCase().startsWith('www.')) {
        return false;
    }
    return isValidDomain(domain);
};
/**
 * Takes a URL string and removes https, http, www or the combination of previous ones.
 * Additionally, removes '/' in the end of the string and lowercases it.
 */
export const serializeRawDomain = (domain) => {
    return domain
        .replace(/^(https?:\/\/(?:www\.|(?!www)))|^(www\.)/, '')
        .replace(/\/$/, '')
        .toLocaleLowerCase();
};
const withHttp = (url) => url.replace(/^(?:(.*:)?\/\/)?(.*)/i, (match, schema, nonSchemaUrl) => schema ? match : `http://${nonSchemaUrl}`);
const getDomainWithoutSubdomain = (string) => {
    const urlParts = new URL(string).hostname.split('.');
    return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join('.');
};
export const extractDomainFromString = (string) => {
    try {
        const hostname = getDomainWithoutSubdomain(withHttp(string));
        if (isValidDomain(hostname)) {
            return hostname;
        }
        return undefined;
    }
    catch {
        return undefined;
    }
};
export const attemptToFixDomain = (maybeDomain, onFixedCallback) => {
    if (!maybeDomain) {
        return maybeDomain;
    }
    const isValidDomain = isBasicValidDomain(maybeDomain);
    if (isValidDomain) {
        return serializeRawDomain(maybeDomain);
    }
    const maybeFixedDomain = extractDomainFromString(maybeDomain);
    if (maybeFixedDomain) {
        const serializedFixedDomain = serializeRawDomain(maybeFixedDomain);
        if (onFixedCallback) {
            onFixedCallback(maybeDomain, serializedFixedDomain);
        }
        return serializedFixedDomain;
    }
    return maybeDomain;
};
//# sourceMappingURL=domains.js.map